import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseModalComponent } from '@src/shared/modal/base-modal/base-modal.component';
import { ModalLayoutComponent } from '@src/shared/modal/base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-gambling-customer-information-modal',
  imports: [ModalLayoutComponent],
  templateUrl: './gambling-customer-information-modal.component.html',
  styleUrl: './gambling-customer-information-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GamblingCustomerInformationModalComponent extends BaseModalComponent {}
